// src/App.js
import React from "react";
import { Box } from "@mui/material";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UnderConstruction from "./components/UnderConstruction";
// import Publications from "./pages/Publications";
import Workspace from "./pages/Workspace";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <NavBar />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<UnderConstruction />} />
            {/* <Route path="/grid" element={<Grid />} /> */}
            <Route path="/workspace" element={<Workspace />} />
            <Route path="/work" element={<Workspace />} />
            {/* <Route path="/news" element={<Publications />} /> */}
            {/* <Route path="/publication" element={<Publications />} /> */}
          </Routes>
        </Box>
        <Footer />
      </Box>
    </Router>
  );
};

export default App;
